var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForbidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12708 6.14769L17.8532 16.8738C19.0712 15.4141 19.6992 13.5515 19.6136 11.6522C19.5281 9.75298 18.7352 7.95442 17.3908 6.61008C16.0465 5.26574 14.2479 4.47286 12.3487 4.3873C10.4494 4.30174 8.58685 4.92968 7.12708 6.14769V6.14769ZM16.8748 17.8523L6.14862 7.12615C4.9306 8.58593 4.30266 10.4485 4.38822 12.3478C4.47378 14.247 5.26666 16.0456 6.611 17.3899C7.95534 18.7343 9.75391 19.5271 11.6532 19.6127C13.5524 19.6983 15.415 19.0703 16.8748 17.8523V17.8523ZM5.63631 5.63631C9.15046 2.12123 14.8486 2.12123 18.3637 5.63631C21.8788 9.15046 21.8788 14.8486 18.3637 18.3637C14.8495 21.8788 9.15138 21.8788 5.63631 18.3637C2.12123 14.8495 2.12123 9.15138 5.63631 5.63631V5.63631Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden);
export default __webpack_public_path__ + "static/media/forbidden.4e0eda9c6548079a88064308f1dee39d.svg";
export { ForwardRef as ReactComponent };